var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-box"},[(_vm.show)?_c('img',{attrs:{"src":_vm.src,"width":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }